import { Config, DefaultConfig } from '@core/models/config.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '@redux/actions';

export const initialConfigState: Config = DefaultConfig;

const _configReducer = createReducer(
  initialConfigState,
  on(actions.fullUpdateConfig, (state, { newConfig }) => newConfig)
);

export function configReducer(state: Config | undefined, action: Action) {
  return _configReducer(state, action);
}
